import tw from 'tailwind-styled-components'

export const TwListView = tw.div`
  min-w-full
  group/list
  select-none
`

export const TwListViewHeader = tw.div`
  grid
  transition-opacity
  opacity-0
  duration-100
  group-hover/list:opacity-100
`

export const TwCol = tw.div`
  flex items-center
  text-placeholder
  text-small-label
  grow
  first:pl-[82px]
  h-[16px]
`

export const TwBody = tw.div<{$nonInteractive?: boolean}>`
  flex
  flex-col
  justify-stretch
  items-stretch
  text-body
  text-primary
  relative
  ${p => (p.$nonInteractive ? '!cursor-default pointer-events-none' : ``)}
`

export const TwRowContainer = tw.div`
  group/row
  flex
  flex-col
  hoverable-group
`

export const TwRowShell = tw.div`
  grid-rows-min-40-auto
  group
  grid
`

export const TwRow = tw(TwRowShell)<{$active: boolean}>`
  cursor-pointer
  border-0
  rounded-8
  border-0
  border-solid
  border-line-base
  listview-hoverable-row
  select-none
  ${p =>
    p.$active
      ? `
    !bg-background-hover
    !shadow-sm-list
    !z-1
    !relative
  `
      : ''}
`

export const TwCell = tw.div`
  flex items-start justify-start
  grow
  pr-8
  relative
`

export const TwInnerCell = tw.div`
  flex items-center
  grow
  min-h-[40px]
  max-w-full
`

export const TwDummy = tw.div`
  h-24
  mr-4
`

export const TwCellFunctions = tw.div`
  flex
  items-center
  mr-6
`

export const TwCellFunction = tw.div`
  flex items-center
  justify-center
  w-24
  h-24
`

export const TwCellFunctionsCompensator = tw.div`
  flex
  items-center
  w-[48px]
`

export const TwDropPlaceholder = tw.div<{ $static?: boolean }>`
    z-20
    left-0
    right-0
    h-[3px]
    bg-action-default
    pointer-events-none
    transition-opacity
    duration-100
    w-full
    left-auto
    right-auto
    !h-[1px]
    before:content-['']
    before:w-4
    before:h-4
    before:bg-action-default
    before:absolute
    before:left-[-2px]
    before:top-1/2
    before:-translate-y-1/2
    before:rounded-full
    opacity-1
    ${p => (p.$static ? '' : 'absolute')}
`

export const TwHighlighter = tw.div<{$visible: boolean}>`
  absolute
  top-0
  left-0
  h-full
  w-[3px]
  bg-action-default
  rounded-bl-4
  rounded-tl-4
  ${p => (p.$visible ? '' : 'hidden')}
`
